import React, {useEffect, useRef, useState} from 'react';
import cl from "./FormMuseumEventVisitsEditor.module.css";
import {Button, FormHelperText} from "@mui/material";
import FormMuseumEventVisitsEditorItem from "./FormMuseumEventVisitsEditorItem";
import "../../formComponents/helperText.css";

const FormMuseumEventVisitsEditor = ({label, initPresets, controlRef, initDataRefs, readOnly, infoText}) => {

    const [cardIdCounter, setCardIdCounter] = useState(0);
    const [cards, setCards] = useState(initPresets.map((x, index) => ({ id: index, data: x})));
    const [errorMessage, setErrorMessage] = useState("");

    const controlRefCards = useRef([]); // {id, current}

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                validate: validate,
                validateItems: validate,
                validateNotEmpty: validateNotEmpty,
                getData: getDataItems,
                getItems: getDataItems,
                setErrorMessage: setErrorMessage,
            };
        }
    })

    function validate() {
        let isValid = true;

        for (const card of cards) {
            var cardRef = controlRefCards.current.find(x => x.id === card.id);
            if (!cardRef.current.validate())
                isValid = false;
        }

        return isValid;
    }

    function getDataItems() {
        return cards.map(card => controlRefCards.current.find(x => x.id === card.id).current.getData());
    }

    function validateNotEmpty(errorMessage) {
        if (cards.length > 0)
            return true;
        setErrorMessage(errorMessage);
        return false;
    }

    function handleAdd() {
        setCards([...cards, { id: `new${cardIdCounter}`, data: undefined }]);
        setCardIdCounter(prev => prev + 1);
        setErrorMessage("");
    }

    function handleDelete(cardId) {;
        setCards(cards.filter(x => x.id !== cardId));
    }

    return (
        <div className={cl.main}>
            {infoText && <FormHelperText sx={{marginLeft:"14px", marginBottom:"15px",whiteSpace:"pre-line"}} className="helperText">
                {infoText}
            </FormHelperText>}
            {label && <p className={cl.label}>{label}</p>}
            <div className={cl.itemsArea}>
                {cards.length > 0 ? cards.map((card, index) =>
                    <FormMuseumEventVisitsEditorItem
                        key={card.id}
                        id={card.id}
                        initData={card.data}
                        index={index}
                        onDelete={handleDelete}
                        controlRef={controlRefCards}
                        initDataRefs={initDataRefs}
                        readOnly={readOnly}
                    />) : <span className={`${cl.emptyListLabel} ${errorMessage ? cl.error : ""}`}>(список пуст)</span>}
            </div>
            {!readOnly && <div className={cl.buttonsArea}>
                <FooterButton
                    label="Добавить вариант посещения"
                    onClick={handleAdd}
                    sx={{width: "560px"}}
                />
            </div>}
            {errorMessage && <FormHelperText error sx={{marginLeft:"14px", marginTop:"5px"}}>{errorMessage}</FormHelperText>}
        </div>
    );
};

const FooterButton = ({label, onClick, sx}) => {
    return <Button variant="outlined" size="medium" onClick={onClick} sx={sx}>{label}</Button>
}

export default FormMuseumEventVisitsEditor;